export default __webpack_public_path__ + "static/media/user.402641d4.svg";